import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { ActivityFeed } from "@/features/activity/components/activity-feed";

// F4-A: feed de actividad (camino ÚNICO: GET /api/activity sobre el log maestro).
export const activityRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/activity",
  component: ActivityFeed,
});
